var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('dialog-scroll-lock', _vm._g(_vm._b({
    attrs: {
      "content-class": _vm.$attrs['content-class'] + (_vm.loading ? ' hidden' : '')
    }
  }, 'dialog-scroll-lock', _vm.$attrs, false), _vm.$listeners), [_vm.loading ? _c('dialog-scroll-lock', {
    attrs: {
      "fullscreen": "",
      "transition": null,
      "value": true
    },
    on: {
      "input": function (v) {
        return _vm.$emit('input', v);
      }
    }
  }, [_c('div', {
    staticClass: "fill-height d-flex justify-center align-center",
    on: {
      "click": function ($event) {
        return _vm.$emit('input', false);
      }
    }
  }, [_c('v-progress-circular', {
    attrs: {
      "color": "white",
      "indeterminate": ""
    }
  })], 1)]) : _vm._e(), _vm._t("default")], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }